import {
  ModeEnum,
  NativeOpenStorageOptionsInterface,
} from '@gfc-flash/plugin-native-storage-sqlite';
import { StorageNameEnum, TypeProviderEnum } from '@gfc-flash/package-ref';
import { PatternAccessKeyEnum } from '@gfc-flash/package-pattern';
import { TypeStorageEnum } from '@gfc-flash/service-storage';
import config from '../../capacitor.config';
import { ServiceAuthentificationConfigInterface } from '@gfc-flash/service-authentification';
import {
  AuthorizationCookieEnum,
  AuthorizationHeaderEnum,
  AuthorizationSchemaEnum,
} from '@gfc-flash/package-authentification';
import { Capacitor } from '@capacitor/core';
import { generatedEnvironment } from '@env/environment.generated';

export const environment = {
  appId: config.appId,
  appName: config.appName,
  appUrl: 'https://archetype.dev.geniusflash-conception.com',
  databaseCachingRequest: {
    mode: ModeEnum.ENCRYPTION,
    version: 1,
    encrypted: true,
    database: 'CachingRequestServiceDev',
    tables: ['requests'],
    secret: generatedEnvironment.databases.cachingRequest.secret.replace(
      /-/g,
      '',
    ),
    newSecret: generatedEnvironment.databases.cachingRequest.newSecret.replace(
      /-/g,
      '',
    ),
  } as NativeOpenStorageOptionsInterface,
  databaseStorage: {
    database: 'ArchetypeDev',
    version: 1,
    encrypted: true,
    tables: ['storage'],
    mode: ModeEnum.ENCRYPTION,
    secret: generatedEnvironment.databases.storage.secret.replace(/-/g, ''),
    newSecret: generatedEnvironment.databases.storage.newSecret.replace(
      /-/g,
      '',
    ),
  } as NativeOpenStorageOptionsInterface,
  optionsAuthentification: {
    accessToken: {
      authorizationCookieKey: AuthorizationCookieEnum.AUTHORIZATION,
      authorizationHeaderKey: AuthorizationHeaderEnum.AUTHORIZATION,
      authorizationSchema: AuthorizationSchemaEnum.BEARER,
      tokenExpiresIn: '5m',
      tokenPattern: PatternAccessKeyEnum.ACCESS_KEY,
      storageExpiresIn: '5m',
    },
    api: {
      host: 'https://api.dev.geniusflash-conception.com',
      name: 'gfc-flash/api-authentification',
    },
    app: {
      clientId: generatedEnvironment.clientId,
      uuid: generatedEnvironment.uuid,
    },
    appToken: {
      authorizationCookieKey: AuthorizationCookieEnum.APP_TOKEN,
      authorizationHeaderKey: AuthorizationHeaderEnum.APP_TOKEN,
      tokenExpiresIn: '2h',
      tokenPattern: PatternAccessKeyEnum.APP_KEY,
      storageExpiresIn: '2h',
    },
    credentialsMode: Capacitor.isNativePlatform() ? 'hybrid' : 'cookies',
    credential: {
      keys: ['login', 'password', 'loginPattern', 'passwordPattern'],
      storageExpiresIn: '30d',
    },
    csrfToken: {
      authorizationCookieKey: AuthorizationCookieEnum.CSRF_TOKEN,
      authorizationHeaderKey: AuthorizationHeaderEnum.CSRF_TOKEN,
      tokenExpiresIn: '2h',
      tokenPattern: PatternAccessKeyEnum.CSRF_TOKEN_32_KEY,
      storageExpiresIn: '2h',
    },
    database: {
      options: {
        database: 'ServiceAuthentification',
        version: 1,
        encrypted: true,
        tables: ['authentification'],
        mode: ModeEnum.ENCRYPTION,
        secret: generatedEnvironment.databases.authentification.secret.replace(
          /-/g,
          '',
        ),
        newSecret:
          generatedEnvironment.databases.authentification.newSecret.replace(
            /-/g,
            '',
          ),
      },
    },
    opt: {
      tokenExpiresIn: '30d',
      storageExpiresIn: '30d',
    },
    provider: {
      storageExpiresIn: '30d',
    },
    totp: {
      tokenExpiresIn: '30d',
      storageExpiresIn: '30d',
    },
    social: {
      options: {
        [TypeProviderEnum.FACEBOOK]: {
          appId: config.appId,
          clientToken: config.appId,
        },
        [TypeProviderEnum.GOOGLE]: {
          mode: 'online',
          webClientId: config.appId,
        },
        [TypeProviderEnum.TWITTER]: {
          clientId: config.appId,
          redirectUrl: config.appId,
        },
      },
    },
    storage: {
      accessTokenKey: `${config.appName!.replace(/-/g, '_')}:${StorageNameEnum.AUTHENTIFICATION_ACCESS_TOKEN}`,
      appTokenKey: `${config.appName!.replace(/-/g, '_')}:${StorageNameEnum.AUTHENTIFICATION_APP_TOKEN}`,
      credentialKey: `${config.appName!.replace(/-/g, '_')}:${StorageNameEnum.AUTHENTIFICATION_CREDENTIAL}`,
      csrfTokenKey: `${config.appName!.replace(/-/g, '_')}:${StorageNameEnum.AUTHENTIFICATION_CSRF_TOKEN}`,
      otpKey: `${config.appName!.replace(/-/g, '_')}:${StorageNameEnum.AUTHENTIFICATION_OTP}`,
      providerKey: `${config.appName!.replace(/-/g, '_')}:${StorageNameEnum.AUTHENTIFICATION_PROVIDER}`,
      totpKey: `${config.appName!.replace(/-/g, '_')}:${StorageNameEnum.AUTHENTIFICATION_TOTP}`,
      typeStorage: TypeStorageEnum.DATABASE,
    },
  } as ServiceAuthentificationConfigInterface,
  production: true,
  version: '1.0.0-dev',
};
